export enum QuoteStatusEnum {
    Cotado = "Cotado",
    Recalculado = "Recalculado",
    Aceito = "Aceito",
    Rejeitado = "Rejeitado",
    Pendente = "Pendente"
}


// WEBPACK FOOTER //
// ./src/services/interfaces/trade/precificacao/QuoteStatusEnum.ts